export default __webpack_public_path__ + "static/media/discord.12e7d362.svg";